var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitelogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000010275858880812253070000011245142470631582130_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75.8 14.3",
    style: {
      enableBackground: "new 0 0 75.8 14.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7B69F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40,10.9 40,5.4 30.8,10.4 30.2,9.2 41.3,3.2 41.3,8.7 51.5,3.2 51.5,8.7 60.6,3.7 61.3,4.9 50.1,10.9  50.1,5.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,13.9V0.3h3v11.1h8.3l-0.4,2.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,4.2c-0.3-0.7-0.7-1.1-1.2-1.4S20,2.3,19,2.3c-1.1,0-1.9,0.1-2.5,0.4s-0.9,0.6-0.9,1.2s0.2,0.8,0.5,1.1 c0.3,0.2,1,0.4,1.9,0.6L20.9,6c1.7,0.3,2.9,0.7,3.6,1.4s1.2,1.6,1.2,2.8c0,1.3-0.6,2.3-1.7,3.1s-2.7,1.1-4.8,1.1 c-1.5,0-2.8-0.2-3.8-0.5c-1-0.4-1.8-0.9-2.3-1.6c-0.5-0.7-0.8-1.6-0.9-2.8h3.1c0.1,0.9,0.5,1.5,1.1,1.9s1.5,0.6,2.8,0.6 c1.1,0,2-0.1,2.5-0.4s0.9-0.7,0.9-1.3c0-0.5-0.2-0.8-0.6-1.1c-0.4-0.3-1-0.5-1.8-0.6L18,8.2c-1.9-0.2-3.2-0.7-4.1-1.4 S12.6,5.2,12.6,4c0-0.8,0.2-1.5,0.8-2.1s1.2-1.1,2.2-1.4S17.8,0,19.1,0c1.9,0,3.3,0.3,4.3,0.9c1,0.6,1.7,1.6,2,2.9L22.4,4.2 L22.4,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,8.5v5.5h-3V0.3h10.8v2.5h-7.8V6h7.4v2.5H67.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitelogo2);
export default __webpack_public_path__ + "static/media/sitelogo2.d4893057fbf7ee31d7791fee0dd41626.svg";
export { ForwardRef as ReactComponent };